module.exports = __webpack_public_path__ + "static/media/CloseUp.107bf96d.jpeg";